/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import styled from 'styled-components';
import { Loader } from '../../../../UiKit';
import { PickerImageViewer } from '../OrderPickerImages/PickerImageViewer';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';

export function InstructionsImagesV1({ orderId, getImages }) {
  if (!orderId) return null;
  return (
    <>
      <div
        className='tw-text-[1.7rem] tw-font-medium  tw-ml-2 tw-text-zinc-600 tw-mt-10 tw-cursor-pointer tw-mb-2'
        data-dd-privacy='mask'
      >
        Instructions Images
      </div>
      <OrderRiderImagesContainer orderId={orderId} getImages={getImages} />
    </>
  );
}

function OrderRiderImagesContainer({ orderId, getImages }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const queryKeys = ['lifeline_apis', 'get_Rider_images', orderId];
  const getRiderImgsEndPoint = `${lifelineEndPoints.GET_RIDER_IMAGES}/${orderId}`;
  const { data, isLoading, isError } = useQueryCall(
    { enabled: getImages },
    getRiderImgsEndPoint,
    queryKeys,
  );
  if (isLoading) return <Loader />;

  if (isError || data?.length === 0)
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={
          isError
            ? 'something went wrong'
            : 'No instructions images shared by customer'
        }
      />
    );

  return (
    <InstructionsImagesV1.Container data-dd-privacy='hidden'>
      <InstructionsImagesV1.RiderImages>
        <PickerImageViewer
          images={data?.map((item) => ({ src: item }))}
          activeIndex={activeIndex}
          updateActiveIndex={setActiveIndex}
        />
      </InstructionsImagesV1.RiderImages>
      <InstructionsImagesV1.RiderImageDetails>
        {data?.map((item, index) => (
          <div
            className='RiderImagsList'
            role='button'
            tabIndex={0}
            key={index}
            onClick={() => setActiveIndex(index)}
          ></div>
        ))}
      </InstructionsImagesV1.RiderImageDetails>
    </InstructionsImagesV1.Container>
  );
}

InstructionsImagesV1.Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  margin-left: 2rem;
`;

InstructionsImagesV1.RiderImages = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 60%;
`;

InstructionsImagesV1.RiderImageDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  height: 100%;
  margin-right: 0.5rem;
`;
